/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RefreshNftMetadataResponse
 */
export interface RefreshNftMetadataResponse {
    /**
     * 
     * @type {number}
     * @memberof RefreshNftMetadataResponse
     */
    refreshed: number;
    /**
     * 
     * @type {number}
     * @memberof RefreshNftMetadataResponse
     */
    missingMetadata: number;
}

export function RefreshNftMetadataResponseFromJSON(json: any): RefreshNftMetadataResponse {
    return RefreshNftMetadataResponseFromJSONTyped(json, false);
}

export function RefreshNftMetadataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefreshNftMetadataResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'refreshed': json['refreshed'],
        'missingMetadata': json['missingMetadata'],
    };
}

export function RefreshNftMetadataResponseToJSON(value?: RefreshNftMetadataResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'refreshed': value.refreshed,
        'missingMetadata': value.missingMetadata,
    };
}


